import React from 'react';
import PropTypes from 'prop-types';
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { Skeleton } from 'antd';
import { TrendUp } from '@phosphor-icons/react';
import Typography from '../../components/Typography';
import COLORS from '../../util/constants/colors';
import { formatDateSlash } from '../../global/validation';

const CHART_HEIGHT = 260;
const X_AXIS_HEIGHT = 52;
const CHART_MARGIN = { bottom: 16 };

const MairaCallVolume = ({ callVolume, loading }) => {
  const trend = (callVolume?.trend || []).map((row) => ({
    date: formatDateSlash(row.date),
    calls: row.count,
  }));

  return (
    <div className="maira-panel maira-call-volume">
      <Typography variant="text" size="medium" bold>
        <TrendUp color={COLORS.BLUE_PRIMARY_LITE} size={16} weight="bold" />
        &nbsp;
        Call Volume
      </Typography>
      {loading ? (
        <Skeleton active />
      ) : (
        <ResponsiveContainer width="100%" height={CHART_HEIGHT}>
          <LineChart data={trend} margin={CHART_MARGIN}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="date"
              height={X_AXIS_HEIGHT}
              padding={{ left: 24, right: 24 }}
              tickLine={false}
            />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="calls"
              name="Daily Calls"
              stroke={COLORS.BLUE_PRIMARY_LITE}
              dot={false}
              activeDot={{ r: 6 }}
              strokeWidth={2}
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

MairaCallVolume.propTypes = {
  callVolume: PropTypes.object,
  loading: PropTypes.bool,
};

MairaCallVolume.defaultProps = {
  callVolume: {},
  loading: false,
};

export default MairaCallVolume;
